var map = {
	"./decidim/avatar-multiuser.png": 6656,
	"./decidim/brands/google.svg": 9199,
	"./decidim/cc-badge.png": 5386,
	"./decidim/decidim-logo.svg": 5746,
	"./decidim/default-avatar.svg": 8942,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 2690,
	"./decidim/icons.svg": 2686,
	"./decidim/pattern.png": 286,
	"./decidim/placeholder-card-g.svg": 6771,
	"./decidim/placeholder-card-l.svg": 5544,
	"./decidim/placeholder.jpg": 5247,
	"./decidim/remixicon.symbol.svg": 2455,
	"./decidim/vendor/leaflet/layers-2x.png": 9546,
	"./decidim/vendor/leaflet/layers.png": 3889,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 3560,
	"./decidim/vendor/leaflet/marker-icon.png": 5383,
	"./decidim/vendor/leaflet/marker-shadow.png": 1863,
	"./decidim/vendor/social-share-button/douban.svg": 3814,
	"./decidim/vendor/social-share-button/email.svg": 6483,
	"./decidim/vendor/social-share-button/facebook.svg": 6357,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 8303,
	"./decidim/vendor/social-share-button/hacker_news.svg": 7767,
	"./decidim/vendor/social-share-button/linkedin.svg": 1435,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 2004,
	"./decidim/vendor/social-share-button/pinterest.svg": 7141,
	"./decidim/vendor/social-share-button/reddit.svg": 1269,
	"./decidim/vendor/social-share-button/telegram.svg": 3948,
	"./decidim/vendor/social-share-button/tumblr.svg": 1875,
	"./decidim/vendor/social-share-button/twitter.svg": 5650,
	"./decidim/vendor/social-share-button/vkontakte.svg": 7308,
	"./decidim/vendor/social-share-button/wechat.svg": 6535,
	"./decidim/vendor/social-share-button/whatsapp.svg": 4487,
	"./decidim/vendor/social-share-button/x.svg": 3555,
	"./decidim/vendor/social-share-button/xing.svg": 3125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1585;